export default "__VITE_ASSET__2PJ13uEL__"